// extracted by mini-css-extract-plugin
export default {"breakpointxs":"0","gp-card":"GPCard_gp-card__taC6U","gp-card__icon":"GPCard_gp-card__icon__Ihcuj","gp-card__link":"GPCard_gp-card__link__snBbi"};